import { ref } from 'vue'
import { useStore } from '@gx-vuex'
import { getWxSign, getWxSignV2 } from '@/services/mobile'

export default function useWxShare() {
  const shareTitle = ref('')
  const sharePicture = ref('')
  const shareDescription = ref('')

  const store = useStore()

  try {
    // @ts-ignore
    shareTitle.value = config.title || shareInfo?.shareTitle || document.title
    // @ts-ignore
    sharePicture.value = config.picture || shareInfo?.fullUrl || shareInfo?.sharePicture
    // @ts-ignore
    shareDescription.value = config.description || shareInfo?.shareDescription || shareTitle.value
  } catch (e) {}

  const wxShare = async (config?: { title, picture, description }) => {
    if (config) {
      shareTitle.value = config.title
      sharePicture.value = config.picture
      shareDescription.value = config.description
    }
    // const url = encodeURIComponent(location.href)
    const url = location.href
    const response: any = await getWxSign({
      url
    })

    if (response) {
      const share_info = { //分享到朋友圈
        title: shareTitle.value, // 分享标题
        desc: shareDescription.value, // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: sharePicture.value, // 分享图标
      }

      if (/QQ\/\d/i.test(window.navigator.userAgent)) {
        // @ts-ignore
        setShareInfo({
          title: shareTitle.value, // 分享标题,
          summary: shareDescription.value, // 分享内容
          desc: shareDescription.value, // 分享内容
          pic: sharePicture.value, // 分享图片
          WXconfig: {
            swapTitleInWX: true,
            appId: 'wxeea695faaf961bff',
            timestamp: response.timestamp,
            nonceStr: response.nonceStr,
            signature: response.signature
          }
        })
      } else {
        wx.config({
          debug: false,
          appId: 'wxeea695faaf961bff',
          timestamp: response.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.nonceStr, // 必填，生成签名的随机串
          signature: response.signature || '', // 必填，签名，见附录1
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone'
          ], // 必填，需要使用的JS接口列表
          // openTagList:['wx-open-launch-app']
        })
        wx.ready(function () {
          if (wx.onMenuShareAppMessage) {
            wx.onMenuShareAppMessage({
              ...share_info,
              success: function () {
                store.point.shareClick('wechat', store.global.details.newsType)
              },
              cancel: function () {
              }
            })
            wx.onMenuShareTimeline({
              ...share_info,
              success: function () {
                store.point.shareClick('moments', store.global.details.newsType)
              },
              cancel: function () {
              }
            })
          } else {
            wx.updateAppMessageShareData({
              ...share_info,
              success: function () {
                store.point.shareClick('wechat', store.global.details.newsType)
              },
              cancel: function () {
              }
            })
            wx.updateTimelineShareData({
              ...share_info,
              success: function () {
                store.point.shareClick('moments', store.global.details.newsType)
              },
              cancel: function () {
              }
            })
          }
          wx.onMenuShareQQ({
            ...share_info,
            success: function () {
              store.point.shareClick('more', store.global.details.newsType)
            },
            cancel: function () {
            }
          })
          wx.onMenuShareWeibo({
            ...share_info,
            success: function () {
              store.point.shareClick('sina', store.global.details.newsType)
            },
            cancel: function () {
            }
          })
          wx.onMenuShareQZone({
            ...share_info,
            success: function () {
              store.point.shareClick('more', store.global.details.newsType)
            },
            cancel: function () {
            }
          })
        })
      }
    }
  }

  const wxShareV2 = async () => {
    // const url = encodeURIComponent(location.href)
    const url = location.href
    const response: any = await getWxSignV2({
      url
    })

    if (response) {
      if (/QQ\/\d/i.test(window.navigator.userAgent)) {
        // @ts-ignore
        setShareInfo({
          WXconfig: {
            swapTitleInWX: true,
            appId: 'wx9ec103d70ef0c88f',
            timestamp: response.timestamp,
            nonceStr: response.nonceStr,
            signature: response.signature
          }
        })
      } else {
        wx.config({
          debug: false,
          appId: 'wx9ec103d70ef0c88f',
          timestamp: response.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.nonceStr, // 必填，生成签名的随机串
          signature: response.signature || '', // 必填，签名，见附录1
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone'
          ], // 必填，需要使用的JS接口列表
          openTagList:['wx-open-launch-app']
        })

        wx.ready(() => {

        })

        wx.error(() => {
          store.global.setGlobalData({
            wechatTagReady: false
          })
        })
      }
    }
  }

  return {
    wxShare,
    wxShareV2
  }
}
